/**
 * Enum outlining some of the fixed values that
 * a question can be expected to have
 */
enum QuestionFixedAnswerType {
  NOT_DONE = '[NOT DONE]',
}

export default QuestionFixedAnswerType;
